import React from 'react';
import { FloatingCard } from './FloatingCard';

/**
 * Named demos a write-up can drop in.
 *
 * Registered by name rather than imported into the data file, so the content
 * stays plain data — a piece of writing should be able to say “put the floating
 * card here” without importing a React component to do it.
 */
export const demos: Record<string, () => JSX.Element> = {
  floating: FloatingCard
};